import DoubleCalendarDashboard from './DoubleCalendarDashboard';

export default DoubleCalendarDashboard;